import {z} from '@hono/zod-openapi';

import {ASSISTANT_ENTITY_CONTEXT_ID_MAX_CHARACTERS} from '../constants/ASSISTANT_ENTITY_CONTEXT_ID_MAX_CHARACTERS';
import {ASSISTANT_ENTITY_CONTEXT_LABEL_MAX_CHARACTERS} from '../constants/ASSISTANT_ENTITY_CONTEXT_LABEL_MAX_CHARACTERS';
import {ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS} from '../constants/ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS';

const id = z.string().min(1).max(ASSISTANT_ENTITY_CONTEXT_ID_MAX_CHARACTERS);
const text = z.string().min(1).max(ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS);
const label = z.string().min(1).max(ASSISTANT_ENTITY_CONTEXT_LABEL_MAX_CHARACTERS);
const MAX_RENTING_ERRORS = 20;

/** Bounded facts from the mounted rental-order page. The entire slice is untrusted model input. */
export const assistantRentalOrderContextSchema = z
  .object({
    rentalOrderId: id,
    orderNumber: text,
    state: z.enum(['draft', 'reserved', 'rented', 'returned', 'closed', 'canceled']),
    plannedPeriod: z.object({
      from: z.string().datetime({offset: true}),
      to: z.string().datetime({offset: true}),
    }),
    plannedPeriodDisplay: z.object({from: label, to: label}).optional(),
    vehicle: z.object({id, label}),
    customer: z.object({id, label}).nullable(),
    lastKnownMileage: z
      .object({
        mileage: z.number().nonnegative(),
        datedOn: z.string().date(),
        source: text,
      })
      .nullable(),
    isRentable: z.boolean().optional(),
    rentingErrors: z.array(text).max(MAX_RENTING_ERRORS).optional(),
    cancellationReason: text.nullable().optional(),
  })
  .openapi('AssistantRentalOrderContext');

export type AssistantRentalOrderContext = z.infer<typeof assistantRentalOrderContextSchema>;
